export default "__VITE_ASSET__CMPw8SEp__"